import { Family } from '../types/family';
import { BonusTx, OccurrenceState } from '../types/activity';
import { Db } from '../types/shared';

export const DEFAULT_OCC: OccurrenceState = { status: 'odprto', sync: 'synced' };

export function uid(prefix: string): string {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}

export function withOcc(db: Db, familyId: string, templateId: string, patch: Partial<OccurrenceState>): Db {
  const fam = db.occ[familyId] ?? {};
  const cur = fam[templateId] ?? DEFAULT_OCC;
  return { ...db, occ: { ...db.occ, [familyId]: { ...fam, [templateId]: { ...cur, ...patch } } } };
}

export function withFamily(db: Db, familyId: string, fn: (f: Family) => Family): Db {
  return { ...db, families: db.families.map((f) => (f.id === familyId ? fn(f) : f)) };
}

/** Vstavi ali zamenja zapis z istim id – ista izvedba nikoli ne ustvari dveh priznanj. */
export function upsertTx(db: Db, tx: BonusTx): Db {
  return { ...db, ledger: [tx, ...db.ledger.filter((t) => t.id !== tx.id)] };
}

export function removeTx(db: Db, id: string): Db {
  return { ...db, ledger: db.ledger.filter((t) => t.id !== id) };
}
